"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalEventTrap = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var stop = function (e) { return e.stopPropagation(); };
var blockEverything = {
    // Clipboard Events
    onCopy: stop,
    onCut: stop,
    onPaste: stop,
    // Input Events
    onCompositionEnd: stop,
    onCompositionStart: stop,
    onCompositionUpdate: stop,
    onSelect: stop,
    // Mouse Events
    onAuxClick: stop,
    onClick: stop,
    onContextMenu: stop,
    onDoubleClick: stop,
    onDrag: stop,
    onDragEnd: stop,
    onDragEnter: stop,
    onDragExit: stop,
    onDragLeave: stop,
    onDragOver: stop,
    onDragStart: stop,
    onDrop: stop,
    onMouseDown: stop,
    onMouseEnter: stop,
    onMouseLeave: stop,
    onMouseMove: stop,
    onMouseOut: stop,
    onMouseOver: stop,
    onMouseUp: stop,
    // Key Events
    onKeyDown: stop,
    onKeyPress: stop,
    onKeyUp: stop,
    // Touch Events
    onTouchCancel: stop,
    onTouchEnd: stop,
    onTouchMove: stop,
    onTouchStart: stop,
    // Pointer Events
    onPointerDown: stop,
    onPointerMove: stop,
    onPointerUp: stop,
    onPointerCancel: stop,
    onPointerEnter: stop,
    onPointerLeave: stop,
    onPointerOver: stop,
    onPointerOut: stop,
    // Focus Events (they bubble in React!)
    onFocus: stop,
    onBlur: stop,
    // Form Events
    onBeforeInput: stop,
    onChange: stop,
    onInput: stop,
    onReset: stop,
    onSubmit: stop,
    // Wheel Events
    onWheel: stop,
    // Animation Events
    onAnimationStart: stop,
    onAnimationEnd: stop,
    onAnimationIteration: stop,
    onTransitionEnd: stop,
};
/** Prevents https://reactjs.org/docs/portals.html#event-bubbling-through-portals */
var PortalEventTrap = function (props) { return React.createElement("div", tslib_1.__assign({}, blockEverything, props, { "data-portal-trap": '' })); };
exports.PortalEventTrap = PortalEventTrap;
exports.PortalEventTrap.displayName = 'PortalEventTrap';
//# sourceMappingURL=PortalEventTrap.js.map